import { IconButton } from "@material-ui/core";
import { ThumbDownAlt } from "@material-ui/icons";
import * as React from "react";
import { Confirm } from "react-admin";
export const RejectIconButton = props => {
  const [open, setOpen] = React.useState(false);
  const handleClick = e => {
    e.stopPropagation();
    setOpen(true);
  };
  const handleDialogClose = () => {
    setOpen(false);
    props?.cancelOnClick?.(props?.record);
  };
  const handleConfirm = () => {
    if (props?.validation && !props?.validation?.()) {
      return;
    }
    props?.onClick?.(props?.record);
    setOpen(false);
  };
  return (
    <>
      <IconButton onClick={handleClick} color="primary">
        <ThumbDownAlt />
      </IconButton>
      <Confirm
        isOpen={open}
        loading={props?.isLoading}
        title={props?.title ? props.title : ""}
        content={props?.content ? props?.content : "Do you approve of transaction?"}
        confirm="Yes"
        cancel="Cancel"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};
export default RejectIconButton;
